/* Suitality adaptive logo: on hover the venue icons and taglines cycle, then return to the page's own venue. */
(function () {
  var ORDER = ['bed', 'plane', 'boat', 'glass', 'cutlery', 'spa'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(b) {
    var tags = {};
    try { tags = JSON.parse(b.getAttribute('data-tags') || '{}'); } catch (e) {}
    var home = b.getAttribute('data-venue') || 'bed';
    var wrap = b.querySelector('.s-brand__tag');
    var first = wrap && wrap.querySelector('.s-brand__tagtxt');
    var cur = home, timer = null, idx = ORDER.indexOf(home);
    function icon(k) { return b.querySelector('.s-brand__icon[data-icon="' + k + '"]'); }
    function show(k) {
      if (k === cur || !tags[k]) return;
      var oi = icon(cur), ni = icon(k);
      if (oi) { oi.classList.remove('is-on'); oi.classList.add('is-out'); (function (el) { setTimeout(function () { if (!el.classList.contains('is-on')) el.classList.remove('is-out'); }, 460); })(oi); }
      if (ni) { ni.classList.remove('is-out'); void ni.offsetWidth; ni.classList.add('is-on'); }
      if (wrap) {
        var old = wrap.querySelector('.s-brand__tagtxt.is-on');
        var t;
        if (k === home && first) { t = first; t.classList.remove('is-out'); }
        else { t = document.createElement('span'); t.className = 's-brand__tagtxt'; t.setAttribute('aria-hidden', 'true'); t.textContent = tags[k]; wrap.appendChild(t); }
        void t.offsetWidth; t.classList.add('is-on');
        if (old) {
          old.classList.remove('is-on'); old.classList.add('is-out');
          (function (el) { setTimeout(function () { if (el === first) { if (!el.classList.contains('is-on')) el.classList.remove('is-out'); } else if (el.parentNode) { el.parentNode.removeChild(el); } }, 460); })(old);
        }
      }
      cur = k;
    }
    function next() { idx = (idx + 1) % ORDER.length; show(ORDER[idx]); }
    b.addEventListener('mouseenter', function () {
      if (reduce && reduce.matches) return;
      clearInterval(timer); idx = ORDER.indexOf(cur);
      setTimeout(function () { if (timer !== null) next(); }, 120);
      timer = setInterval(next, 1100);
    });
    b.addEventListener('mouseleave', function () {
      clearInterval(timer); timer = null; idx = ORDER.indexOf(home); show(home);
    });
  }
  function run() { Array.prototype.forEach.call(document.querySelectorAll('[data-brand]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
